export const SESSION_STORAGE_HOME_BASE_URL_KEY = 'updatedApiRootHomeBaseUrl';
export const SESSION_STORAGE_PLATFORM_BASE_URL_KEY = 'updatedApiRootPlatformBaseUrl';
